import React from "react"
import {FieldTableCellProps, getTableCellStyle} from "../../../../../render/table/table-cell";
import {FieldViewSize} from "../../../../../const";
import FieldTaskType_Editable from "../editable/editable";

export default function FieldTaskType_TableCell(props:FieldTableCellProps):React.ReactElement {

    const onChange = (value:any) => {
        props.field.fieldParams.tableCellOnValueChange!(props.listItem, value, props.manager)
    }

    return (
        <div className="cell-flex p-h-0" style={getTableCellStyle(props)}>

            <FieldTaskType_Editable size={FieldViewSize.SMALL}
                                    iconOnly={props.column.width!<80}
                                    className="w-100-percent h-100-percent"
                                    disabled={props.manager.isReadOnly}
                                    field={props.field}
                                    model={props.listItem.task}
                                    onChange={onChange} />

        </div>

    )

}



// import React from "react"
// import {FieldTableCellProps, FieldTableCellState, getTableCellStyle} from "../../../../../render/table/table-cell";
// import TaskTypeIcon from "../../../../../../gd-components/icons/task-icon/task-icon-ui5";
//
// // const debug = "FieldStatus_TableCell"
// const debug = false
//
//
// export default class FieldTaskType_TableCell extends React.Component<FieldTableCellProps, FieldTableCellState> {
//
//     constructor(props:FieldTableCellProps) {
//         super(props)
//
//         this.state = {
//             isHovered: false,
//             showPopover: false
//         }
//     }
//
//     onMouseEnter = () => {
//
//         if (!this.props.field.canEdit(this.props.listItem.item)) return
//
//
//         if (!this.state.isHovered) this.setState({
//             isHovered   : true
//         })
//     }
//
//     onMouseLeave = () => {
//         if (this.state.showPopover) return //
//
//         if (this.state.isHovered) this.setState({
//             isHovered   : false
//         })
//     }
//
//     onValueChange(value: any, hidePopover:boolean=true) {
//
//
//         this.props.listItem.task.taskTypeId = value
//         this.props.listItem.task.save()
//
//         hidePopover && this.hidePopover()
//
//     }
//
//     onClick = () => {
//         if (!this.props.field.canEdit(this.props.listItem.item)) return
//
//         this.setState({
//             showPopover     : !this.state.showPopover
//         })
//     }
//
//     onOptionClick = (option:Option) => {
//         this.onValueChange(option.value)
//     }
//
//     hidePopover = () => {
//         this.setState({
//             showPopover     : false,
//             isHovered       : false
//         })
//     }
//
//     renderHovered() {
//
//         const field = this.props.field
//
//         const classes = Classes("cell-flex ui5-txt-less-important-small", this.props.column.id, {
//             'is-hovered'        : this.state.isHovered
//         })
//
//         const style : style = getTableCellStyle(this.props)
//
//         return (
//             <React.Fragment>
//                 <div className={classes} style={style} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave} >
//                     <div className="ui5-field-editable is-hovered w-100-percent h-100-percent" onClick={this.onClick}>
//
//                         {this.renderValue(style.width)}
//
//                         <div className="buttons flex-no-shrink">
//                             <div className="btn-arrow"/>
//                         </div>
//                     </div>
//
//                     {this.state.showPopover &&
//                         <field.components.PopoverMenu parent={this} field={this.props.field} model={this.props.listItem.item} />
//                     }
//                 </div>
//             </React.Fragment>
//         )
//     }
//
//     renderValue(width?:number) {
//
//         const taskType = gd.session.taskTypes.get(this.props.listItem.task.taskTypeId);
//
//         // If column is small - render icon only !!!
//         if (!width || width<90) {
//             return (
//                 <div className={"flex-row-center-center w-100-percent"}>
//                     <TaskTypeIcon taskTypeId={this.props.listItem.task.taskTypeId}/>
//                 </div>
//             )
//         }
//
//         return (
//             <div className={"flex-row-left-center w-100-percent"}>
//                 <TaskTypeIcon className="m-r-5 flex-row-center-center min-w-15" taskTypeId={this.props.listItem.task.taskTypeId}/>
//                 <div className="max-w-100-percent txt-truncate">{taskType?.name}</div>
//             </div>
//         )
//     }
//
//     renderNotHovered() {
//         const classes = Classes("cell-flex ui5-txt-less-important-small", this.props.column.id, {
//             // 'is-hovered'        : this.state.isHovered
//         })
//
//         const style : style = getTableCellStyle(this.props)
//
//         return (
//             <React.Fragment>
//                 <div className={classes} style={style} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
//
//                     {this.renderValue(style.width)}
//
//                 </div>
//             </React.Fragment>
//         )
//     }
//
//     render() {
//         // debug && console.log(debug, "render()", this.props)
//         debug && console.log(debug, "render() isHovered=", this.state.isHovered)
//
//         if (this.state.isHovered) return this.renderHovered()
//         else return this.renderNotHovered()
//     }
// }
//
//
//
